import React, { useState } from "react";
import { Modal } from "antd";
import { Assets } from "../../../constants/images";

const MediaCollectionPreview = ({ selectedFiles, onRemoveFile }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);

  const openModal = (index) => {
    // Only open modal for images
    const file = selectedFiles[index];
    if (file && file.type.startsWith("image/")) {
      setSelectedIndex(index);
      setShowModal(true);
    }
  };

  const getImageIndices = () => {
    return selectedFiles
      .map((file, index) => ({ file, index }))
      .filter(({ file }) => file.type.startsWith("image/"))
      .map(({ index }) => index);
  };

  const navigateImages = (direction) => {
    const imageIndices = getImageIndices();
    const currentImageIndex = imageIndices.indexOf(selectedIndex);

    if (direction === "prev" && currentImageIndex > 0) {
      setSelectedIndex(imageIndices[currentImageIndex - 1]);
    } else if (
      direction === "next" &&
      currentImageIndex < imageIndices.length - 1
    ) {
      setSelectedIndex(imageIndices[currentImageIndex + 1]);
    }
  };

  const renderModalContent = () => {
    const file = selectedFiles[selectedIndex];
    if (!file || !file.type.startsWith("image/")) return null;

    return (
      <div className="modal-image-container">
        <img
          src={URL.createObjectURL(file)}
          alt=""
          style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
          onError={(e) => (e.target.src = Assets.GeneralPlaceholder)}
        />
      </div>
    );
  };

  const renderFilePreview = (file, index) => {
    if (file.type.startsWith("image/")) {
      return (
        <div key={index} className="preview-item image-preview-item">
          <img
            src={URL.createObjectURL(file)}
            alt=""
            onClick={() => openModal(index)}
            onError={(e) => (e.target.src = Assets.GeneralPlaceholder)}
          />
          <button className="remove-btn" onClick={() => onRemoveFile(index)}>
            ×
          </button>
        </div>
      );
    } else if (file.type.startsWith("video/")) {
      return (
        <div key={index} className="preview-item video-preview">
          <video src={URL.createObjectURL(file)} muted />
          <div className="video-play-overlay">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
              <path d="M8 5v14l11-7z" />
            </svg>
          </div>
          <button className="remove-btn" onClick={() => onRemoveFile(index)}>
            ×
          </button>
        </div>
      );
    }
    return null;
  };

  const imageIndices = getImageIndices();
  const currentImageIndex = imageIndices.indexOf(selectedIndex);

  return (
    <>
      <div className="media-collection-preview">
        <div className="preview-header">
          <span>{selectedFiles.length} file(s) selected</span>
        </div>
        <div className="preview-grid">
          {selectedFiles.map((file, index) => renderFilePreview(file, index))}
        </div>
      </div>

      <Modal
        open={showModal}
        onCancel={() => setShowModal(false)}
        footer={null}
        width="90vw"
        centered
        className="media-collection-modal"
      >
        <div className="modal-navigation">
          {currentImageIndex > 0 && (
            <button
              className="nav-btn prev-btn"
              onClick={() => navigateImages("prev")}
            >
              ‹
            </button>
          )}
          {currentImageIndex < imageIndices.length - 1 && (
            <button
              className="nav-btn next-btn"
              onClick={() => navigateImages("next")}
            >
              ›
            </button>
          )}
        </div>
        <div className="modal-content">{renderModalContent()}</div>
        <div className="modal-info">
          <span>
            {currentImageIndex + 1} of {imageIndices.length}
          </span>
        </div>
      </Modal>
    </>
  );
};

export default MediaCollectionPreview;
